export const ModalPlugin = {
  install: function (Vue, options) {
    const eventBus = new Vue()
    Vue.prototype.$modalEvent = eventBus
    Vue.myGlobalMethod = function () {
    }

    Vue.directive('my-directive', {
      bind(el, binding, vnode, oldVnode) {
      }
    })

    Vue.mixin({
      created: function () {
      }
    })

    Vue.prototype.$openModal = function ({ type, text, title, callback }) {
      eventBus.$emit("openModal", { type, text, title, callback })
    }
    Vue.prototype.$modalError = function ({ type, title, callback, text }) {
      eventBus.$emit("modalError", { type, title, callback, text })
    }
    Vue.prototype.$closeModal = function (type) {
      eventBus.$emit("closeModal", type)
    }
  }
}
